//
//
//
//
//
//
//
//
//

export default {
    layout: 'empty',
    props: {
        error: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            pageNotFound: '404 Not Found',
            accessDenied: 'Access denied',
            otherError: 'An error occurred',
        }
    },
    head() {
        let title
        switch (this.error.statusCode) {
            case 404:
                title = this.pageNotFound
                break
            case 401:
                title = this.accessDenied
                break
            default:
                title = this.otherError
        }
        return {
            title,
        }
    },
    computed: {
        errorMessage() {
            let result
            switch (this.error.statusCode) {
                case 404:
                    result = this.pageNotFound
                    break
                case 401:
                    result = this.accessDenied
                    break
                default:
                    result = this.otherError
            }
            return result
        },
    },
}
